export default "__VITE_ASSET__709f2291__"